"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_helmet_1 = require("react-helmet");
const BlogPostingMicrodata_1 = require("./BlogPostingMicrodata");
const ProductMicrodata_1 = require("./ProductMicrodata");
exports.ItemListMicrodata = ({ url, products, blogPostings }) => {
    let positionCounter = 0;
    const numberOfItems = (products && products.length ? products.length : 0) +
        (blogPostings && blogPostings.length ? blogPostings.length : 0);
    const jsonObject = {
        '@context': 'http://schema.org',
        '@type': 'ItemList',
        url,
        numberOfItems,
        itemListElement: [
            ...(products && products.length
                ? products.map(item => {
                    positionCounter++;
                    return {
                        '@type': 'ListItem',
                        position: positionCounter,
                        item: JSON.parse(ProductMicrodata_1.getProductJson(item)),
                    };
                })
                : []),
            ...(blogPostings && blogPostings.length
                ? blogPostings.map(item => {
                    positionCounter++;
                    return {
                        '@type': 'ListItem',
                        position: positionCounter,
                        item: JSON.parse(BlogPostingMicrodata_1.getBlogPostingJson(item)),
                    };
                })
                : []),
        ],
    };
    return (React.createElement(react_helmet_1.Helmet, null,
        React.createElement("script", { type: "application/ld+json" }, JSON.stringify(jsonObject))));
};
